import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { FilialService } from '../../../shared/api/model/service/filial.service';

export const fetchFilialsAsync = createAsyncThunk('filial/fetchFilialsAsync', async () => {
  return await FilialService.fetchFilials();
});

export const setActiveFilial = createAction<string>('filial/setActiveFilial');
